import React from "react";
import Navbar from "../Components/Navbar";
import subpagebanner from "../Assets/subpagebanner.png";
import footer from "../Assets/footer.png";

const About = () => {
  return (
    <div className="App">
      <Navbar />
      <img src={subpagebanner} alt="" />
      <div className="home-container"></div>
      <div className="bodycopy-container">
        <h1 className="primary-header">Teams</h1>
        <br />
        <h4 className="subheader center-text">
          Congratulations to the Top 8 Finalists of the NUS–SYNAPXE–IMDA AI
          Innovation Challenge 2026!
          <br />
          <br />
          We are pleased to recognise the outstanding teams whose submissions
          demonstrated strong innovation, technical quality, and potential
          real-world impact in addressing important healthcare challenges. The
          teams are listed in alphabetical order.
        </h4>
        <br />
        <br />
        <br />
        <h3 className="center-text">
          AAAMedMaster
          <br />
          <br />
          ASSURE
          <br />
          <br />
          Jet2Holiday
          <br />
          <br />
          Med-SEAL
          <br />
          <br />
          NextCare
          <br />
          <br />
          SHA-2
          <br />
          <br />
          SilverGait
          <br />
          <br />
          wait for a name
        </h3>
        <br />
        <br />
        <br />
        <br />
        <br />

        <img src={footer} alt="" />
        <br />
        <br />
      </div>
    </div>
  );
};

export default About;
